<template>
   <div>
      <v-card class="payments-card">
         <v-card-title class="align-start payments-card-title">
            <div class="payment-header-main">
               <div class="d-flex align-center">
                  <span class="payments-title">Membership Payments</span>
                  <v-divider class="mx-4" inset vertical></v-divider>
               </div>
               <div class="payment-filter-panel mt-5">
                  <v-text-field
                     v-model="filters.search"
                     label="Search name, Member ID, IC/Passport, transaction or description"
                     prepend-inner-icon="mdi-magnify"
                     dense
                     outlined
                     clearable
                     hide-details
                     class="payment-search"
                  ></v-text-field>
                  <v-select
                     v-model="filters.membertype"
                     :items="memberTypes"
                     label="Member Type"
                     dense
                     outlined
                     clearable
                     hide-details
                     class="payment-filter-select"
                  ></v-select>
                  <v-select
                     v-model="filters.payyear"
                     :items="paymentYears"
                     label="Payment Year"
                     dense
                     outlined
                     clearable
                     hide-details
                     class="payment-filter-select small"
                  ></v-select>
                  <v-select
                     v-model="filters.status"
                     :items="statusOptions"
                     label="Status"
                     dense
                     outlined
                     clearable
                     hide-details
                     class="payment-filter-select"
                  ></v-select>
                  <v-btn text color="primary" class="clear-filter-btn" @click="clearFilters">
                     <v-icon left small>mdi-filter-remove</v-icon>
                     Clear
                  </v-btn>
               </div>
            </div>
            <v-spacer></v-spacer>
            <div class="d-flex flex-column align-start">
               <v-btn color="#14532d" dark class="mt-2" @click="$inertia.visit('/admin/external-payment')">
                  <v-icon left>mdi-receipt-text-check</v-icon>
                  External Payment
               </v-btn>
               <v-btn color="green darken-3" dark class="mt-2"  @click="$inertia.visit('/admin/manual-payment')">
                  Manual Payment
               </v-btn>
               <v-btn color="blue darken-3" dark class="mt-2" @click="exportCsv">
                  <v-icon left>mdi-microsoft-excel</v-icon>
                  Export to Excel
               </v-btn>
            </div>
         </v-card-title>

         <v-card-text class="pa-0">
            <!-- <v-data-table
               :headers="headers"
               :items="tableRows"
               :loading="loading"
               :items-per-page="10"
               dense
               class="legacy-payment-table"
            >
               <template v-slot:body="{ items }">
                  <tbody>
                     <tr v-for="item in items" :key="item.rowKey" :class="{ 'payment-member-row': item.isGroup }">
                        <td v-if="item.isGroup" :colspan="headers.length">
                           <strong>{{ item.groupText }}</strong>
                        </td>
                        <template v-else>
                           <td>{{ item.no }}</td>
                           <td>{{ item.payyear }}</td>
                           <td>{{ item.paymentdate ? formatDate(item.paymentdate) : '-' }}</td>
                           <td>{{ item.description }}</td>
                           <td>{{ item.trxnid }}</td>
                           <td>RM {{ Number(item.amount || 0).toFixed(2) }}</td>
                           <td>{{ statusCode(item.trxnstatus) }}</td>
                           <td class="text-right">
                              <v-btn x-small color="primary" class="mr-1 receipt-btn" @click="openMipReceipt(item)">
                                 MIP Receipt
                              </v-btn>
                              <v-btn x-small color="primary" class="mr-1 receipt-btn" :href="toyyibReceiptUrl(item)" target="NEW" :disabled="!item.trxnid">
                                 TP Receipt
                              </v-btn>
                              <v-btn v-if="item.trxnstatus !== '01'" x-small color="success" class="receipt-btn" @click="markPaid(item)">
                                 Update Success
                              </v-btn>
                           </td>
                        </template>
                     </tr>
                  </tbody>
               </template>
            </v-data-table> -->
            <!-- TABS -->
             <v-tabs v-model="activeTab" background-color="grey lighten-4">
               <v-tab>All Payments</v-tab>
               <v-tab>
                  Pending Receipt Approval
                  <v-chip v-if="pendingReceipts.length > 0" x-small color="red" dark class="ml-2">
                     {{ pendingReceipts.length }}
                  </v-chip>
               </v-tab>
             </v-tabs>

             <v-tabs-items v-model="activeTab">
               <!-- TAB 1: All Payments -->
                <v-tab-item>
                  <v-data-table
                     :headers="headers"
                     :items="filteredPayments"
                     :loading="loading"
                     :items-per-page="10"
                     dense
                     class="legacy-payment-table payment-data-table"
                     sort-by="paymentdate"
                     :sort-desc="true"
                  >
                     <template v-slot:item.fullname="{ item }">
                        <div class="member-cell">
                           <div class="member-name">{{ item.fullname || '-' }}</div>
                           <div class="member-sub">{{ item.membertype || '-' }}</div>
                        </div>
                     </template>
                     <template v-slot:item.paymentdate="{ item }">
                        {{ item.paymentdate ? formatDate(item.paymentdate) : '-' }}
                     </template>
                     <template v-slot:item.description="{ item }">
                        <div class="payment-purpose">
                           <div class="payment-purpose-title">{{ paymentForLabel(item) }}</div>
                           <div v-if="paymentForMeta(item)" class="payment-purpose-meta">{{ paymentForMeta(item) }}</div>
                        </div>
                     </template>
                     <template v-slot:item.receipt_no="{ item }">
                        <span v-if="isSuccessfulPayment(item)" class="receipt-no-text">
                           {{ item.receipt_no || 'Not generated' }}
                        </span>
                        <span v-else class="muted-value">Available after success</span>
                     </template>
                     <template v-slot:item.trxnid="{ item }">
                        <div class="reference-cell">
                           <div>{{ item.trxnid || '-' }}</div>
                           <div class="payment-method-chip">{{ paymentMethodLabel(item) }}</div>
                        </div>
                     </template>
                     <template v-slot:item.amount="{ item }">
                        <span class="amount-text">RM {{ Number(item.amount || 0).toFixed(2) }}</span>
                     </template>
                     <template v-slot:item.trxnstatus="{ item }">
                        <v-chip x-small :color="statusColor(item.trxnstatus)" dark>
                           {{ statusCode(item.trxnstatus) }}
                        </v-chip>
                     </template>
                     <template v-slot:item.actions="{ item }">
                        <div class="payment-actions">
                           <v-btn x-small depressed dark class="receipt-btn action-details" @click="openPaymentDetails(item)">
                              Details
                           </v-btn>
                           <v-btn
                              v-if="hasPaymentDocument(item)"
                              x-small
                              class="receipt-btn action-doc"
                              :href="paymentDocUrl(item)"
                              target="_blank"
                           >
                              View Doc
                           </v-btn>
                           <v-btn v-else x-small disabled class="receipt-btn">
                              No Doc
                           </v-btn>
                           <v-btn v-if="canIssueMipReceipt(item)" x-small depressed dark class="receipt-btn action-primary" @click="openMipReceipt(item)">
                              MIP Receipt
                           </v-btn>
                           <v-btn v-else x-small disabled class="receipt-btn">
                              MIP Receipt
                           </v-btn>
                           <v-btn
                              v-if="canViewToyyibReceipt(item)"
                              x-small
                              class="receipt-btn action-primary"
                              :href="toyyibReceiptUrl(item)"
                              target="NEW"
                           >
                              TP Receipt
                           </v-btn>
                           <v-btn v-if="item.trxnstatus !== '01'" x-small depressed dark class="receipt-btn action-success" @click="markPaid(item)">
                              <v-icon x-small left>mdi-check-circle</v-icon>
                              Success
                           </v-btn>
                           <v-btn v-if="canEditPayment(item)" x-small depressed dark class="receipt-btn action-edit" @click="openEditPayment(item)">
                              <v-icon x-small left>mdi-pencil</v-icon>
                              Edit
                           </v-btn>
                           <v-btn v-if="canRejectPayment(item)" x-small depressed dark class="receipt-btn action-decline" @click="openRejectPayment(item)">
                              <v-icon x-small left>mdi-close-circle</v-icon>
                              Decline
                           </v-btn>
                        </div>
                     </template>
                  </v-data-table>
                </v-tab-item>

                <!-- TAB 2: Pending Receipt Approval -->
                 <v-tab-item>
                  <v-data-table
                     :headers="pendingHeaders"
                     :items="pendingReceipts"
                     :loading="loading"
                     :items-per-page="10"
                     dense
                     class="legacy-payment-table"
                     sort-by="paymentdate"
                     :sort-desc="true"
                  >
                     <template v-slot:item.paymentdate="{ item }">
                        {{ item.paymentdate ? formatDate(item.paymentdate) : '-' }}
                     </template>
                     <template v-slot:item.description="{ item }">
                        <div class="payment-purpose">
                           <div class="payment-purpose-title">{{ paymentForLabel(item) }}</div>
                           <div v-if="paymentForMeta(item)" class="payment-purpose-meta">{{ paymentForMeta(item) }}</div>
                        </div>
                     </template>
                     <template v-slot:item.amount="{ item }">
                        RM {{ Number(item.amount || 0).toFixed(2) }}
                     </template>
                     <template v-slot:item.trxnstatus="{ item }">
                        <v-chip x-small :color="statusColor(item.trxnstatus)" dark>
                           {{ statusCode(item.trxnstatus) }}
                        </v-chip>
                     </template>
                     <template v-slot:item.document="{ item }">
                        <a v-if="hasPaymentDocument(item)"
                           :href="paymentDocUrl(item)"
                           target="_blank"
                           class="blue--text text-decoration-none">
                           <v-icon small color="blue">mdi-file-document</v-icon>
                           View Receipt
                        </a>
                        <span v-else-if="item.document && item.documentpath" class="red--text text-caption">
                           File missing
                        </span>
                        <span v-else class="grey--text">No document</span>
                     </template>
                     <template v-slot:item.actions="{ item }">
                        <div class="pending-review-actions">
                           <v-btn small depressed dark class="review-action-btn action-success" @click="markPaid(item)">
                              <v-icon small left>mdi-check-circle</v-icon>
                              Approve
                           </v-btn>
                           <v-btn small depressed dark class="review-action-btn action-edit" @click="openEditPayment(item)">
                              <v-icon small left>mdi-pencil</v-icon>
                              Edit
                           </v-btn>
                           <v-btn small depressed dark class="review-action-btn action-decline" @click="openRejectPayment(item)">
                              <v-icon small left>mdi-close-circle</v-icon>
                              Decline
                           </v-btn>
                        </div>
                     </template>
                  </v-data-table>
                 </v-tab-item>
             </v-tabs-items>
         </v-card-text>
      </v-card>

      <v-dialog v-model="manualReceiptDialog" max-width="620" persistent overlay-color="#0f172a" overlay-opacity="0.78">
         <v-card class="payment-form-dialog">
            <v-card-title class="payment-form-title manual-receipt-title">
               <div class="dialog-heading">
                  <div class="dialog-icon manual-receipt-icon">
                     <v-icon color="white">mdi-receipt-text-check</v-icon>
                  </div>
                  <div>
                     <div class="text-h6">Confirm Manual Receipt Payment</div>
                     <div class="payment-detail-subtitle">
                        {{ manualReceiptForm.fullname || '-' }} - {{ manualReceiptForm.memberid || '-' }}
                     </div>
                  </div>
               </div>
               <v-spacer></v-spacer>
               <v-btn icon :disabled="savingManualReceipt" @click="closeManualReceiptDialog">
                  <v-icon>mdi-close</v-icon>
               </v-btn>
            </v-card-title>

            <v-card-text class="payment-form-body">
               <v-alert dense text type="info" class="mb-4">
                  Use this confirmation only when MIP has already issued the official receipt manually.
               </v-alert>

               <div class="manual-payment-summary">
                  <div>
                     <span>Payment Year</span>
                     <strong>{{ manualReceiptForm.payyear || '-' }}</strong>
                  </div>
                  <div>
                     <span>Amount</span>
                     <strong>RM {{ Number(manualReceiptForm.amount || 0).toFixed(2) }}</strong>
                  </div>
                  <div>
                     <span>Reference</span>
                     <strong>{{ manualReceiptForm.trxnid || '-' }}</strong>
                  </div>
               </div>

               <div class="manual-receipt-confirmation">
                  <v-checkbox
                     v-model="manualReceiptForm.confirmed"
                     hide-details
                     color="#14532d"
                     label="I confirm that an official MIP receipt has already been issued manually."
                  ></v-checkbox>
                  <div class="manual-receipt-help">
                     The payment will be marked as successful and the outstanding fee for this year will be settled. No new system receipt will be generated.
                  </div>
               </div>

               <v-alert v-if="manualReceiptError" dense text type="error" class="mt-4 mb-0">
                  {{ manualReceiptError }}
               </v-alert>
            </v-card-text>

            <v-card-actions class="payment-form-actions">
               <v-spacer></v-spacer>
               <v-btn text :disabled="savingManualReceipt" @click="closeManualReceiptDialog">Cancel</v-btn>
               <v-btn
                  color="#14532d"
                  dark
                  depressed
                  :loading="savingManualReceipt"
                  :disabled="!manualReceiptForm.confirmed"
                  @click="submitManualReceiptConfirmation"
               >
                  <v-icon left small>mdi-check-circle</v-icon>
                  Confirm Payment
               </v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>

      <v-dialog v-model="editPaymentDialog" max-width="720" persistent overlay-color="#0f172a" overlay-opacity="0.78">
         <v-card class="payment-form-dialog">
            <v-card-title class="payment-form-title">
               <div class="dialog-heading">
                  <div class="dialog-icon warning-icon">
                     <v-icon color="white">mdi-pencil</v-icon>
                  </div>
                  <div>
                     <div class="text-h6">Edit Payment Receipt</div>
                     <div class="payment-detail-subtitle">{{ editForm.fullname || '-' }} - {{ editForm.memberid || '-' }}</div>
                  </div>
               </div>
               <v-spacer></v-spacer>
               <v-btn icon @click="editPaymentDialog = false">
                  <v-icon>mdi-close</v-icon>
               </v-btn>
            </v-card-title>
            <v-card-text class="payment-form-body">
               <div class="dialog-note">
                  <v-icon small color="orange darken-2" class="mr-2">mdi-shield-edit</v-icon>
                  Pending receipt record
               </div>
               <v-row dense>
                  <v-col cols="12" md="4">
                     <v-text-field v-model="editForm.payyear" label="Payment Year" type="number" prepend-inner-icon="mdi-calendar" outlined dense></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                     <v-text-field v-model="editForm.amount" label="Amount" type="number" step="0.01" prefix="RM" outlined dense></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                     <v-text-field
                        :value="formattedEditPaymentDate()"
                        label="Payment Date"
                        prepend-inner-icon="mdi-calendar-clock"
                        append-icon="mdi-chevron-down"
                        outlined
                        dense
                        readonly
                        @click="paymentDatePickerDialog = true"
                        @click:append="paymentDatePickerDialog = true"
                     ></v-text-field>
                     <v-dialog v-model="paymentDatePickerDialog" max-width="680" overlay-color="#0f172a" overlay-opacity="0.45">
                        <v-card class="payment-date-picker-card">
                           <v-card-title class="payment-date-picker-title">
                              <div>
                                 <div class="payment-date-picker-heading">Select Payment Date</div>
                                 <div class="payment-date-picker-subtitle">{{ formattedEditPaymentDate() || 'Choose date and time' }}</div>
                              </div>
                              <v-spacer></v-spacer>
                              <v-btn icon @click="paymentDatePickerDialog = false">
                                 <v-icon>mdi-close</v-icon>
                              </v-btn>
                           </v-card-title>
                           <v-card-text class="payment-date-picker-body">
                              <v-date-picker
                                 v-model="editForm.paymentdateDate"
                                 color="#1f4e79"
                                 no-title
                                 scrollable
                              ></v-date-picker>
                              <v-divider vertical class="mx-2"></v-divider>
                              <v-time-picker
                                 v-model="editForm.paymentdateTime"
                                 color="#1f4e79"
                                 format="24hr"
                                 no-title
                              ></v-time-picker>
                           </v-card-text>
                           <v-card-actions class="payment-date-picker-actions">
                              <v-spacer></v-spacer>
                              <v-btn text @click="paymentDatePickerDialog = false">Cancel</v-btn>
                              <v-btn color="#1f4e79" dark depressed @click="paymentDatePickerDialog = false">Done</v-btn>
                           </v-card-actions>
                        </v-card>
                     </v-dialog>
                  </v-col>
                  <v-col cols="12">
                     <v-select
                        v-model="editForm.paymenttype"
                        :items="paymentTypeOptions"
                        label="Payment For"
                        prepend-inner-icon="mdi-cash-check"
                        outlined
                        dense
                        :disabled="editForm.tabletype === 'renewals'"
                        hint="Choose the fee category being recorded"
                        persistent-hint
                     ></v-select>
                  </v-col>
                  <v-col cols="12">
                     <v-text-field v-model="editForm.trxnid" label="Transaction ID / Reference" prepend-inner-icon="mdi-pound" outlined dense></v-text-field>
                  </v-col>
                  <v-col cols="12">
                     <v-textarea v-model="editForm.description" label="Description" rows="3" prepend-inner-icon="mdi-text-box-outline" outlined dense></v-textarea>
                  </v-col>
               </v-row>
               <v-alert v-if="editError" dense text color="red" class="mt-2">{{ editError }}</v-alert>
            </v-card-text>
            <v-card-actions class="payment-form-actions">
               <v-spacer></v-spacer>
               <v-btn text @click="editPaymentDialog = false">Cancel</v-btn>
               <v-btn color="warning" dark depressed :loading="savingPaymentEdit" @click="submitPaymentEdit">
                  <v-icon left small>mdi-content-save</v-icon>
                  Save Changes
               </v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>

      <v-dialog v-model="rejectPaymentDialog" max-width="600" persistent overlay-color="#0f172a" overlay-opacity="0.78">
         <v-card class="payment-form-dialog">
            <v-card-title class="payment-form-title danger-title">
               <div class="dialog-heading">
                  <div class="dialog-icon danger-icon">
                     <v-icon color="white">mdi-close-circle</v-icon>
                  </div>
                  <div>
                     <div class="text-h6">Decline Payment</div>
                     <div class="payment-detail-subtitle">{{ rejectForm.fullname || '-' }} - {{ rejectForm.memberid || '-' }}</div>
                  </div>
               </div>
               <v-spacer></v-spacer>
               <v-btn icon @click="rejectPaymentDialog = false">
                  <v-icon>mdi-close</v-icon>
               </v-btn>
            </v-card-title>
            <v-card-text class="payment-form-body">
               <div class="dialog-note danger-note">
                  <v-icon small color="red darken-2" class="mr-2">mdi-alert-circle-outline</v-icon>
                  The remarks entered here will be saved for audit and member reference.
               </div>
               <v-textarea
                  v-model="rejectForm.reason"
                  label="Reason / description"
                  rows="4"
                  prepend-inner-icon="mdi-comment-alert-outline"
                  outlined
                  dense
               ></v-textarea>
               <v-alert v-if="rejectError" dense text color="red">{{ rejectError }}</v-alert>
            </v-card-text>
            <v-card-actions class="payment-form-actions">
               <v-spacer></v-spacer>
               <v-btn text @click="rejectPaymentDialog = false">Cancel</v-btn>
               <v-btn color="error" dark depressed :loading="savingPaymentReject" @click="submitPaymentReject">
                  <v-icon left small>mdi-close-circle</v-icon>
                  Decline Payment
               </v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>

      <v-dialog v-model="paymentDetailDialog" max-width="820" overlay-color="#0f172a" overlay-opacity="0.78">
         <v-card v-if="selectedPayment" class="payment-detail-dialog">
            <v-card-title class="payment-detail-title">
               <div>
                  <div class="text-h6">Payment Details</div>
                  <div class="payment-detail-subtitle">
                     {{ selectedPayment.fullname || '-' }} - {{ selectedPayment.memberid || selectedPayment.icpassport || '-' }}
                  </div>
               </div>
               <v-spacer></v-spacer>
               <v-btn icon @click="paymentDetailDialog = false">
                  <v-icon>mdi-close</v-icon>
               </v-btn>
            </v-card-title>

            <v-card-text class="pt-4">
               <v-alert v-if="hasPaymentDocument(selectedPayment)" dense text color="blue" class="mb-4">
                  Uploaded receipt/document is available for this payment.
               </v-alert>
               <v-alert v-else dense text color="grey" class="mb-4">
                  No uploaded receipt/document attached to this payment record.
               </v-alert>

               <v-row dense>
                  <v-col cols="12" md="6">
                     <div class="detail-box">
                        <div class="detail-label">Member</div>
                        <div class="detail-value">{{ detailValue(selectedPayment.fullname) }}</div>
                     </div>
                  </v-col>
                  <v-col cols="12" md="3">
                     <div class="detail-box">
                        <div class="detail-label">Member ID</div>
                        <div class="detail-value">{{ detailValue(selectedPayment.memberid) }}</div>
                     </div>
                  </v-col>
                  <v-col cols="12" md="3">
                     <div class="detail-box">
                        <div class="detail-label">Member Type</div>
                        <div class="detail-value">{{ detailValue(selectedPayment.membertype) }}</div>
                     </div>
                  </v-col>
                  <v-col cols="12" md="4">
                     <div class="detail-box">
                        <div class="detail-label">IC / Passport</div>
                        <div class="detail-value">{{ detailValue(selectedPayment.icpassport) }}</div>
                     </div>
                  </v-col>
                  <v-col cols="12" md="4">
                     <div class="detail-box">
                        <div class="detail-label">Payment Year</div>
                        <div class="detail-value">{{ detailValue(selectedPayment.payyear) }}</div>
                     </div>
                  </v-col>
                  <v-col cols="12" md="4">
                     <div class="detail-box">
                        <div class="detail-label">Amount</div>
                        <div class="detail-value amount-text">RM {{ Number(selectedPayment.amount || 0).toFixed(2) }}</div>
                     </div>
                  </v-col>
                  <v-col cols="12" md="6">
                     <div class="detail-box">
                        <div class="detail-label">Receipt No.</div>
                        <div class="detail-value">{{ detailValue(selectedPayment.receipt_no) }}</div>
                     </div>
                  </v-col>
                  <v-col cols="12" md="6">
                     <div class="detail-box">
                        <div class="detail-label">Transaction ID / Reference</div>
                        <div class="detail-value">{{ detailValue(selectedPayment.trxnid) }}</div>
                     </div>
                  </v-col>
                  <v-col cols="12" md="6">
                     <div class="detail-box">
                        <div class="detail-label">Date Submit</div>
                        <div class="detail-value">
                           {{ selectedPayment.paymentdate ? formatDate(selectedPayment.paymentdate) : '-' }}
                        </div>
                     </div>
                  </v-col>
                  <v-col cols="12" md="6">
                     <div class="detail-box">
                        <div class="detail-label">Status</div>
                        <v-chip x-small :color="statusColor(selectedPayment.trxnstatus)" dark>
                           {{ statusCode(selectedPayment.trxnstatus) }}
                        </v-chip>
                     </div>
                  </v-col>
                  <v-col cols="12" md="6">
                     <div class="detail-box">
                        <div class="detail-label">Source</div>
                        <div class="detail-value">{{ detailValue(selectedPayment.tabletype) }}</div>
                     </div>
                  </v-col>
                  <v-col cols="12">
                     <div class="detail-box">
                        <div class="detail-label">Description</div>
                        <div class="detail-value">{{ detailValue(selectedPayment.description) }}</div>
                     </div>
                  </v-col>
                  <v-col cols="12" v-if="selectedPayment.decline_reason">
                     <div class="detail-box decline-reason-box">
                        <div class="detail-label">Decline Reason</div>
                        <div class="detail-value">{{ detailValue(selectedPayment.decline_reason) }}</div>
                     </div>
                  </v-col>
                  <v-col cols="12" v-if="hasPaymentDocument(selectedPayment)">
                     <div class="detail-box">
                        <div class="detail-label">Uploaded Document</div>
                        <a :href="paymentDocUrl(selectedPayment)" target="_blank" class="detail-document-link">
                           <v-icon small color="blue" class="mr-1">mdi-file-document</v-icon>
                           {{ selectedPayment.document }}
                        </a>
                     </div>
                  </v-col>
               </v-row>
            </v-card-text>

            <v-card-actions>
               <v-btn
                  v-if="hasPaymentDocument(selectedPayment)"
                  color="secondary"
                  :href="paymentDocUrl(selectedPayment)"
                  target="_blank"
               >
                  <v-icon left small>mdi-open-in-new</v-icon>
                  Open Uploaded Doc
               </v-btn>
               <v-spacer></v-spacer>
               <v-btn text @click="paymentDetailDialog = false">Close</v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>
   </div>
</template>

<script>
const axios = require('axios')

export default {
   name: "TableAdmPayments",
   data() {
      return {
         payments: [],
         loading: false,
         filters: {
            search: '',
            membertype: '',
            payyear: '',
            status: '',
         },
         paymentDetailDialog: false,
         selectedPayment: null,
         manualReceiptDialog: false,
         savingManualReceipt: false,
         manualReceiptError: '',
         manualReceiptForm: {
            id: null,
            tabletype: '',
            fullname: '',
            memberid: '',
            payyear: '',
            amount: 0,
            trxnid: '',
            confirmed: false,
         },
         editPaymentDialog: false,
         paymentDatePickerDialog: false,
         savingPaymentEdit: false,
         editError: '',
         editForm: {
            id: null,
            tabletype: '',
            fullname: '',
            memberid: '',
            paymenttype: '',
            description: '',
            payyear: '',
            amount: '',
            paymentdateDate: '',
            paymentdateTime: '',
            trxnid: '',
         },
         rejectPaymentDialog: false,
         savingPaymentReject: false,
         rejectError: '',
         rejectForm: {
            id: null,
            tabletype: '',
            fullname: '',
            memberid: '',
            reason: '',
         },
         memberTypes: [
            { text: 'Corporate', value: 'COR' },
            { text: 'Graduate', value: 'GRA' },
            { text: 'Associate', value: 'ASC' },
            { text: 'Student', value: 'STU' },
            { text: 'Fellow', value: 'FEL' },
            { text: 'Honorary Fellow', value: 'HON' },
         ],
         paymentTypeOptions: [
            { text: 'Annual Subscription Fee', value: 'SF' },
            { text: 'Entrance Fee + Annual Subscription Fee', value: 'EFSF' },
         ],
         statusOptions: [
            { text: 'Success', value: '01' },
            { text: 'Pending Approval', value: '00' },
            { text: 'Payment Pending', value: '02' },
            { text: 'Failed / Rejected', value: '03' },
         ],
         headers: [
            { text: 'Member', value: 'fullname', sortable: true, width: 260 },
            { text: 'Member ID', value: 'memberid', sortable: true, width: 130 },
            { text: 'IC/Passport', value: 'icpassport', sortable: true, width: 150 },
            { text: 'Year', value: 'payyear', sortable: true, width: 90 },
            { text: 'Date Submit', value: 'paymentdate', sortable: true, width: 180 },
            { text: 'Description', value: 'description', sortable: false },
            { text: 'Receipt No.', value: 'receipt_no', sortable: true, width: 190 },
            { text: 'Transaction ID', value: 'trxnid', sortable: false, width: 180 },
            { text: 'Amount', value: 'amount', sortable: true, width: 150 },
            { text: 'Status', value: 'trxnstatus', sortable: true, width: 155 },
            { text: 'Actions', value: 'actions', sortable: false, align: 'end', width: 430 },
         ],
         activeTab: 0,
         pendingHeaders: [
            { text: 'Member', value: 'fullname', sortable: true },
            { text: 'Member ID', value: 'memberid', sortable: false, width: 120 },
            { text: 'Year', value: 'payyear', sortable: true, width: 80 },
            { text: 'Date Submit', value: 'paymentdate', sortable: true, width: 180 },
            { text: 'Description', value: 'description', sortable: false },
            { text: 'Amount', value: 'amount', sortable: true, width: 120 },
            { text: 'Transaction ID', value: 'trxnid', sortable: false, width: 160 },
            { text: 'Status', value: 'trxnstatus', sortable: false, width: 130 },
            { text: 'Receipt Doc', value: 'document', sortable: false, width: 150 },
            { text: 'Actions', value: 'actions', sortable: false, align: 'end', width: 320 },
         ],
      }
   },
   computed: {
      sortedPayments() {
         return [...this.payments].sort((a, b) => {
            return this.paymentTimestamp(b) - this.paymentTimestamp(a)
         })
      },
      paymentYears() {
         return [...new Set(this.payments.map(item => item.payyear).filter(Boolean))]
            .sort((a, b) => Number(b) - Number(a))
      },
      filteredPayments() {
         return this.sortedPayments.filter((item) => {
            return this.matchesSearch(item, this.filters.search)
               && this.matches(item.membertype, this.filters.membertype, true)
               && this.matches(item.payyear, this.filters.payyear, true)
               && this.matches(item.trxnstatus, this.filters.status, true)
         })
      },

      pendingReceipts() {
         return this.filteredPayments.filter(item => item.trxnstatus === '00')
      },

      tableRows() {
         var rows = []
         var currentKey = ''
         this.filteredPayments.forEach((item, index) => {
            var groupKey = [
               item.userid || '',
               item.fullname || '',
               item.memberid || '',
               item.icpassport || '',
               item.membertype || '',
            ].join('|')

            if (groupKey !== currentKey) {
               currentKey = groupKey
               rows.push({
                  rowKey: 'member-' + groupKey,
                  isGroup: true,
                  groupText: this.memberLabel(item),
               })
            }

            rows.push(Object.assign({}, item, {
               rowKey: 'payment-' + (item.tabletype || 'payment') + '-' + item.id,
               no: index + 1,
               isGroup: false,
            }))
         })
         return rows
      },
   },
   mounted() {
      this.initialize()
   },
   methods: {
      initialize() {
         this.loading = true
         axios.get('/admin/payments/list')
         .then((resp) => {
            if (resp.data && resp.data.status === 'OK') {
               this.payments = resp.data.data || []
            } else {
               this.payments = []
            }
         })
         .finally(() => {
            this.loading = false
         })
      },
      matches(value, filter, exact = false) {
         if (!filter) return true
         var source = String(value || '').toLowerCase()
         var target = String(filter || '').toLowerCase()
         return exact ? source === target : source.indexOf(target) !== -1
      },
      matchesSearch(item, filter) {
         if (!filter) return true
         var target = String(filter || '').toLowerCase().trim()
         var haystack = [
            item.fullname,
            item.memberid,
            item.icpassport,
            item.membertype,
            item.description,
            item.decline_reason,
            item.receipt_no,
            item.trxnid,
            item.payyear,
            this.statusCode(item.trxnstatus),
         ].join(' ').toLowerCase()
         return haystack.indexOf(target) !== -1
      },
      paymentTimestamp(item) {
         var value = item.paymentdate || item.created_at || item.updated_at
         var date = value ? new Date(value) : null
         return date && !isNaN(date.getTime()) ? date.getTime() : 0
      },
      clearFilters() {
         this.filters = {
            search: '',
            membertype: '',
            payyear: '',
            status: '',
         }
      },
      memberLabel(item) {
         var parts = []
         if (item.fullname) parts.push(item.fullname)
         if (item.memberid || item.icpassport || item.membertype) {
            parts.push('[ ' + [item.memberid, item.icpassport, item.membertype].filter(Boolean).join(', ') + ' ]')
         }
         return 'Member: ' + parts.join(' ')
      },
      formatDate(e) {
         return this.$moment(new Date(e)).format('YYYY-MM-DD HH:mm:ss')
      },
      isSuccessfulPayment(item) {
         return String(item && item.trxnstatus || '').padStart(2, '0') === '01'
      },
      isToyyibPay(item) {
         if (!item) return false
         var method = String(item.paymentmethod || '').toUpperCase()
         var reference = String(item.trxnid || '').toUpperCase()
         if (method === 'TOYYIBPAY' || item.tabletype === 'renewals') return true
         if (method === 'MANUAL' || method === 'MANUAL_RECEIPT') return false
         if (reference.indexOf('MANUAL-') === 0 || reference.indexOf('RECEIPT-') === 0) return false
         return !!(item.trxnid && !item.document && !item.documentpath)
      },
      canIssueMipReceipt(item) {
         return this.isSuccessfulPayment(item)
      },
      canViewToyyibReceipt(item) {
         return this.isSuccessfulPayment(item) && this.isToyyibPay(item) && !!(item && item.trxnid)
      },
      canEditPayment(item) {
         return String(item && item.trxnstatus || '').padStart(2, '0') === '00'
      },
      canRejectPayment(item) {
         return String(item && item.trxnstatus || '').padStart(2, '0') === '00'
      },
      paymentMethodLabel(item) {
         var method = String(item && item.paymentmethod || '').toUpperCase()
         if (this.isToyyibPay(item)) return 'ToyyibPay'
         if (method === 'MANUAL') return 'Manual by Admin'
         if (method === 'MANUAL_RECEIPT') return 'Manual Receipt'
         if (method === 'ONLINE') return 'Online Payment'
         return method || '-'
      },
      paymentForLabel(item) {
         var description = String(item && item.description || '').trim()
         var descriptionLower = description.toLowerCase()
         var type = String(item && item.paymenttype || '').toUpperCase()
         var year = item && item.payyear ? ' ' + item.payyear : ''

         if (descriptionLower.indexOf('corporate upgrade') !== -1) return 'Corporate Upgrade Fee' + year
         if (descriptionLower.indexOf('graduate upgrade') !== -1) return 'Graduate Upgrade Fee' + year
         if (type === 'EFSF') return 'Entrance Fee + Annual Subscription Fee' + year
         if (type === 'EF') return 'Entrance Fee' + year
         if (type === 'SF') return 'Annual Subscription Fee' + year
         return description || 'Membership Payment'
      },
      paymentForMeta(item) {
         var description = String(item && item.description || '').trim()
         var label = this.paymentForLabel(item)
         if (!description || description.toLowerCase() === label.toLowerCase()) return ''
         return description
      },
      statusCode(e) {
         var status = String(e || '').padStart(2, '0')
         if (status === '01') return '01 - Success'
         if (status === '00') return '00 - Pending Review'
         if (status === '02') return '02 - Pending Gateway'
         if (status === '03') return '03 - Failed'
         return e || '-'
      },
      statusColor(e) {
         var status = String(e || '').padStart(2, '0')
         if (status === '01') return 'green darken-1'
         if (status === '00') return 'orange darken-2'
         if (status === '02') return 'blue darken-1'
         if (status === '03') return 'red darken-1'
         return 'grey'
      },
      detailValue(value) {
         return value === null || value === undefined || value === '' ? '-' : value
      },
      openPaymentDetails(item) {
         this.selectedPayment = item
         this.paymentDetailDialog = true
      },
      hasPaymentDocument(item) {
         if (!(item && item.document && item.documentpath)) return false
         if (item.documentpath === 'renewal-ref') return false
         if (item.document_available === false || item.document_available === 0 || item.document_available === '0') return false
         return true
      },
      paymentDocUrl(item) {
         if (!this.hasPaymentDocument(item)) return '#'
         var path = String(item.documentpath || '').replace(/^\/+|\/+$/g, '')
         var document = String(item.document || '').replace(/^\/+/g, '')
         return '/' + path + '/' + encodeURIComponent(document).replace(/%2F/g, '/')
      },
      toyyibReceiptUrl(item) {
         if (!item.trxnid) return '#'
         return 'https://toyyibpay.com/' + item.trxnid
      },
      openMipReceipt(item) {
         if (!this.canIssueMipReceipt(item)) {
            alert('MIP receipt is only available after the payment is marked as Success.')
            return
         }
         var receipt = window.open('', 'MIP_RECEIPT_' + item.id)
         if (!receipt) return
         var amount = Number(item.amount || 0).toFixed(2)
         var memberName = item.fullname || '-'
         var memberId = item.memberid || '-'
         var description = this.paymentForLabel(item)
         var receiptNo = item.receipt_no || '-'
         var paymentDate = item.paymentdate ? this.formatReceiptDate(item.paymentdate) : '-'
         var transactionNo = item.trxnid || '-'
         var qrData = encodeURIComponent([
            'MIP Official Receipt',
            'Receipt No: ' + receiptNo,
            'Member: ' + memberName,
            'Member ID: ' + memberId,
            'Amount: RM ' + amount,
            'Payment Ref: ' + transactionNo,
            'Year: ' + (item.payyear || '-')
         ].join('\n'))
         var qrUrl = 'https://api.qrserver.com/v1/create-qr-code/?size=76x76&margin=0&data=' + qrData
         var html = `
            <html>
               <head>
                  <title>MIP Receipt</title>
                  <style>
                     @page { size: A4 portrait; margin: 0; }
                     * { box-sizing: border-box; }
                     body {
                        font-family: Arial, Helvetica, sans-serif;
                        color: #000;
                        background: #fff;
                        margin: 0;
                        padding: 0;
                        font-size: 8px;
                        line-height: 1.35;
                     }
                     .receipt-page {
                        width: 794px;
                        min-height: 1123px;
                        margin: 0 auto;
                        padding: 46px 30px;
                        background: #fff;
                     }
                     .receipt-meta {
                        display: flex;
                        justify-content: space-between;
                        align-items: flex-start;
                        font-size: 6px;
                        font-weight: 700;
                        margin-bottom: 10px;
                     }
                     .receipt-meta .system {
                        text-align: right;
                     }
                     .receipt-header {
                        display: grid;
                        grid-template-columns: 82px 330px 76px;
                        column-gap: 8px;
                        align-items: start;
                        justify-content: start;
                     }
                     .receipt-logo {
                        width: 76px;
                        height: 76px;
                        object-fit: contain;
                     }
                     .org-name {
                        font-size: 9px;
                        font-weight: 800;
                        letter-spacing: 0;
                        line-height: 1.15;
                        margin-top: 0;
                        white-space: nowrap;
                     }
                     .org-name-en {
                        font-size: 8px;
                        font-weight: 800;
                        line-height: 1.15;
                        margin-top: 2px;
                     }
                     .org-address {
                        font-size: 8px;
                        line-height: 1.45;
                        margin-top: 3px;
                     }
                     .receipt-qr {
                        width: 76px;
                        height: 76px;
                        object-fit: contain;
                     }
                     .receipt-title {
                        text-align: center;
                        font-size: 8px;
                        font-weight: 800;
                        text-decoration: underline;
                        margin: 28px 0 22px;
                     }
                     .receipt-body {
                        font-size: 11px;
                        line-height: 1.45;
                        margin-top: 0;
                     }
                     .receipt-body strong {
                        font-weight: 800;
                     }
                     .receipt-detail-box {
                        display: inline-block;
                        border: 1px solid #cfd4dc;
                        margin-top: 22px;
                        padding: 8px 10px;
                        min-width: 235px;
                        font-size: 8px;
                        line-height: 1.6;
                        font-weight: 700;
                     }
                     .screen-actions {
                        margin: 16px auto 0;
                        width: 794px;
                        padding: 0 30px;
                        text-align: right;
                     }
                     .screen-actions button {
                        border: 0;
                        border-radius: 4px;
                        color: #fff;
                        cursor: pointer;
                        font-size: 11px;
                        font-weight: 700;
                        margin-left: 8px;
                        padding: 8px 14px;
                        text-transform: uppercase;
                     }
                     .print-btn { background: #2e7d32; }
                     .close-btn { background: #1976d2; }
                     @media print {
                        body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                        .receipt-page { width: 794px; min-height: 1123px; margin: 0; padding: 46px 30px; }
                        .screen-actions { display: none; }
                     }
                  </style>
               </head>
               <body>
                  <div class="receipt-page">
                     <div class="receipt-meta">
                        <div>${this.escapeHtml(this.formatReceiptGeneratedAt())}</div>
                        <div class="system">MOMS - MIP Online Membership System</div>
                     </div>

                     <div class="receipt-header">
                        <img class="receipt-logo" src="/images/miplogo-300x300.png" alt="MIP">
                        <div>
                           <div class="org-name">PERTUBUHAN PERANCANG MALAYSIA</div>
                           <div class="org-name-en">MALAYSIAN INSTITUTE OF PLANNERS</div>
                           <div class="org-address">
                              B-1-02, JALAN SS7/13B, Plaza Kelana Jaya,<br>
                              47301 Petaling Jaya, Selangor.<br>
                              Tel. No: 03-78770636/6037 &nbsp;&nbsp; Fax No: 03-78779636
                           </div>
                        </div>
                        <img class="receipt-qr" src="${qrUrl}" alt="QR Code">
                     </div>

                     <div class="receipt-title">OFFICIAL RECEIPT</div>

                     <div class="receipt-body">
                        Received from <strong>${this.escapeHtml(memberName)} (${this.escapeHtml(memberId)})</strong><br>
                        the sum of RINGGIT MALAYSIA (RM) <strong>${amount} ONLY</strong><br>
                        being paid for <strong>${this.escapeHtml(description)}</strong>
                     </div>

                     <div class="receipt-detail-box">
                        Receipt No.: ${this.escapeHtml(receiptNo)}<br>
                        Amount: RM ${amount}<br>
                        Payment Date: ${this.escapeHtml(paymentDate)}<br>
                        Payment Ref. No:<br>
                        ${this.escapeHtml(transactionNo)}
                     </div>
                  </div>

                  <div class="screen-actions">
                     <button class="print-btn" onclick="window.print()">Print</button>
                     <button class="close-btn" onclick="window.close()">Close</button>
                  </div>
               </body>
            </html>
         `
         receipt.document.open()
         receipt.document.write(html)
         receipt.document.close()
         receipt.focus()
         setTimeout(() => receipt.print(), 500)
      },
      formatReceiptDate(value) {
         return this.$moment(new Date(value)).format('DD/MM/YYYY h:mm A')
      },
      formatReceiptGeneratedAt() {
         return this.$moment(new Date()).format('DD/MM/YYYY, HH:mm')
      },
      escapeHtml(value) {
         return String(value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;')
      },
      markPaid(item) {
         this.manualReceiptError = ''
         this.manualReceiptForm = {
            id: item.id,
            tabletype: item.tabletype,
            fullname: item.fullname || '',
            memberid: item.memberid || '',
            payyear: item.payyear || '',
            amount: item.amount || 0,
            trxnid: item.trxnid || '',
            confirmed: false,
         }
         this.manualReceiptDialog = true
      },
      closeManualReceiptDialog() {
         if (this.savingManualReceipt) return
         this.manualReceiptDialog = false
         this.manualReceiptError = ''
      },
      submitManualReceiptConfirmation() {
         if (!this.manualReceiptForm.confirmed) {
            this.manualReceiptError = 'Please confirm that the official receipt has already been issued manually.'
            return
         }

         this.savingManualReceipt = true
         this.manualReceiptError = ''
         axios.post('/admin/payments/update', {
            id: this.manualReceiptForm.id,
            tabletype: this.manualReceiptForm.tabletype,
            manual_receipt_confirmed: this.manualReceiptForm.confirmed,
         })
         .then((resp) => {
            if (resp.data && resp.data.status === 'OK') {
               this.manualReceiptDialog = false
               this.initialize()
               return
            }

            this.manualReceiptError = (resp.data && resp.data.error) || 'Unable to confirm this payment.'
         })
         .catch(() => {
            this.manualReceiptError = 'Unable to confirm this payment. Please try again.'
         })
         .finally(() => {
            this.savingManualReceipt = false
         })
      },

      toLocalDateParts(value) {
         if (!value) return ''
         return {
            date: this.$moment(new Date(value)).format('YYYY-MM-DD'),
            time: this.$moment(new Date(value)).format('HH:mm'),
         }
      },
      combinedEditPaymentDate() {
         if (!this.editForm.paymentdateDate || !this.editForm.paymentdateTime) return ''
         return `${this.editForm.paymentdateDate} ${this.editForm.paymentdateTime}:00`
      },
      formattedEditPaymentDate() {
         var value = this.combinedEditPaymentDate()
         if (!value) return ''
         return this.$moment(value, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY hh:mm A')
      },
      openEditPayment(item) {
         this.editError = ''
         var paymentDate = this.toLocalDateParts(item.paymentdate)
         this.editForm = {
            id: item.id,
            tabletype: item.tabletype,
            fullname: item.fullname || '',
            memberid: item.memberid || '',
            paymenttype: item.paymenttype || 'SF',
            description: item.description || '',
            payyear: item.payyear || '',
            amount: item.amount || '',
            paymentdateDate: paymentDate.date || '',
            paymentdateTime: paymentDate.time || '',
            trxnid: item.trxnid || '',
         }
         this.editPaymentDialog = true
      },
      submitPaymentEdit() {
         this.editError = ''
         var paymentdate = this.combinedEditPaymentDate()
         if (!this.editForm.description || !this.editForm.payyear || !this.editForm.amount || !paymentdate) {
            this.editError = 'Please complete payment year, amount, date and description.'
            return
         }
         this.savingPaymentEdit = true
         axios.post('/admin/payments/edit', {
            id: this.editForm.id,
            tabletype: this.editForm.tabletype,
            paymenttype: this.editForm.paymenttype,
            description: this.editForm.description,
            payyear: this.editForm.payyear,
            amount: this.editForm.amount,
            paymentdate: paymentdate,
            trxnid: this.editForm.trxnid,
         })
         .then((resp) => {
            if (resp.data && resp.data.status === 'OK') {
               this.editPaymentDialog = false
               this.initialize()
            } else {
               this.editError = (resp.data && resp.data.error) || 'Unable to update payment.'
            }
         })
         .finally(() => {
            this.savingPaymentEdit = false
         })
      },
      openRejectPayment(item) {
         this.rejectError = ''
         this.rejectForm = {
            id: item.id,
            tabletype: item.tabletype,
            fullname: item.fullname || '',
            memberid: item.memberid || '',
            reason: item.decline_reason || '',
         }
         this.rejectPaymentDialog = true
      },
      submitPaymentReject() {
         this.rejectError = ''
         if (!String(this.rejectForm.reason || '').trim()) {
            this.rejectError = 'Please enter decline reason.'
            return
         }
         this.savingPaymentReject = true
         axios.post('/admin/payments/reject', {
            id: this.rejectForm.id,
            tabletype: this.rejectForm.tabletype,
            reason: this.rejectForm.reason,
         })
         .then((resp) => {
            if (resp.data && resp.data.status === 'OK') {
               this.rejectPaymentDialog = false
               this.initialize()
            } else {
               this.rejectError = (resp.data && resp.data.error) || 'Unable to decline payment.'
            }
         })
         .finally(() => {
            this.savingPaymentReject = false
         })
      },
      exportCsv() {
         var rows = [
            ['No', 'Year', 'Date Submit', 'Description', 'Decline Reason', 'Transaction ID', 'Amount', 'Status Code', 'Full Name', 'Member ID', 'IC/Passport', 'Member Type'],
         ]
         this.filteredPayments.forEach((item, index) => {
            rows.push([
               index + 1,
               item.payyear || '',
               item.paymentdate ? this.formatDate(item.paymentdate) : '',
               item.description || '',
               item.decline_reason || '',
               item.trxnid || '',
               Number(item.amount || 0).toFixed(2),
               this.statusCode(item.trxnstatus),
               item.fullname || '',
               item.memberid || '',
               item.icpassport || '',
               item.membertype || '',
            ])
         })

         var csv = rows.map(row => row.map(value => '"' + String(value).replace(/"/g, '""') + '"').join(',')).join('\r\n')
         var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
         var link = document.createElement('a')
         link.href = URL.createObjectURL(blob)
         link.download = 'membership-payments.csv'
         link.click()
         URL.revokeObjectURL(link.href)
      },
   }
}
</script>

<style scoped>
.payments-card {
   border-radius: 4px;
}

.manual-receipt-title {
   border-bottom: 1px solid #dbe4ee;
}

.manual-receipt-icon {
   background: #14532d;
}

.manual-payment-summary {
   background: #f8fafc;
   border: 1px solid #dbe4ee;
   display: grid;
   grid-template-columns: repeat(3, minmax(0, 1fr));
   margin-bottom: 18px;
}

.manual-payment-summary > div {
   border-right: 1px solid #dbe4ee;
   min-width: 0;
   padding: 14px 16px;
}

.manual-payment-summary > div:last-child {
   border-right: 0;
}

.manual-payment-summary span,
.manual-payment-summary strong {
   display: block;
   overflow-wrap: anywhere;
}

.manual-payment-summary span {
   color: #64748b;
   font-size: 11px;
   font-weight: 700;
   margin-bottom: 5px;
   text-transform: uppercase;
}

.manual-payment-summary strong {
   color: #0f172a;
   font-size: 14px;
}

.manual-receipt-confirmation {
   border: 1px solid #86a894;
   padding: 14px 16px;
}

.manual-receipt-confirmation ::v-deep .v-label {
   color: #0f172a;
   font-size: 14px;
   font-weight: 600;
}

.manual-receipt-help {
   color: #475569;
   font-size: 12px;
   line-height: 1.5;
   margin-left: 32px;
   margin-top: 6px;
}

@media (max-width: 600px) {
   .manual-payment-summary {
      grid-template-columns: 1fr;
   }

   .manual-payment-summary > div {
      border-bottom: 1px solid #dbe4ee;
      border-right: 0;
   }

   .manual-payment-summary > div:last-child {
      border-bottom: 0;
   }
}

.payments-card-title {
   padding: 20px 18px 14px;
}

.payment-header-main {
   flex: 1 1 auto;
   max-width: calc(100% - 220px);
}

.payments-title {
   color: #111827;
   font-size: 20px;
   font-weight: 500;
   letter-spacing: 0;
   line-height: 1.35;
}

.payment-filter-panel {
   display: grid;
   grid-template-columns: minmax(320px, 1fr) 190px 150px 180px auto;
   gap: 10px;
   align-items: center;
   max-width: 1160px;
}

.payment-search ::v-deep .v-input__slot,
.payment-filter-select ::v-deep .v-input__slot {
   background: #fff;
}

.clear-filter-btn {
   height: 40px !important;
   justify-self: start;
}

.payment-actions {
   display: flex;
   align-items: center;
   justify-content: flex-end;
   gap: 6px;
   flex-wrap: wrap;
}

.pending-review-actions {
   align-items: center;
   display: flex;
   flex-wrap: wrap;
   gap: 8px;
   justify-content: flex-end;
   min-width: 300px;
}

.review-action-btn {
   border-radius: 4px;
   font-size: 11px;
   font-weight: 700;
   letter-spacing: .2px;
   min-width: 88px;
   text-transform: none;
}

.member-cell {
   min-width: 210px;
}

.member-name {
   color: #111827;
   font-weight: 700;
   line-height: 1.35;
}

.member-sub {
   color: #6b7280;
   font-size: 11px;
   line-height: 1.25;
   margin-top: 2px;
}

.payment-purpose {
   min-width: 190px;
}

.payment-purpose-title {
   color: #111827;
   font-weight: 700;
   line-height: 1.35;
}

.payment-purpose-meta {
   color: #6b7280;
   font-size: 11px;
   line-height: 1.3;
   margin-top: 2px;
}

.reference-cell {
   color: #111827;
   line-height: 1.35;
   overflow-wrap: anywhere;
}

.payment-method-chip {
   color: #4b5563;
   font-size: 11px;
   font-weight: 600;
   margin-top: 2px;
}

.receipt-no-text {
   color: #111827;
   font-weight: 700;
   white-space: nowrap;
}

.muted-value {
   color: #9ca3af;
   font-size: 11px;
}

.amount-text {
   font-weight: 700;
   white-space: nowrap;
}

.export-btn {
   font-size: 12px;
   font-weight: 600;
   letter-spacing: .4px;
}

.receipt-btn {
   border-radius: 4px;
   font-size: 10px;
   font-weight: 600;
   letter-spacing: .5px;
   min-width: 88px;
}

.action-details {
   background: #1f3a5f !important;
   color: #fff !important;
}

.action-doc {
   background: #475569 !important;
   color: #fff !important;
}

.action-primary {
   background: #1d4ed8 !important;
   color: #fff !important;
}

.action-success {
   background: #166534 !important;
   color: #fff !important;
}

.action-edit {
   background: #92400e !important;
   color: #fff !important;
}

.action-decline {
   background: #991b1b !important;
   color: #fff !important;
}

.action-details:hover,
.action-doc:hover,
.action-primary:hover,
.action-success:hover,
.action-edit:hover,
.action-decline:hover {
   filter: brightness(1.08);
}

.payment-form-dialog {
   border-radius: 8px;
   overflow: hidden;
}

.payment-form-title {
   background: #f3f6fa;
   border-bottom: 1px solid #e5e7eb;
   padding: 18px 22px;
}

.danger-title {
   background: #fff5f5;
}

.dialog-heading {
   align-items: center;
   display: flex;
   gap: 12px;
   min-width: 0;
}

.dialog-icon {
   align-items: center;
   border-radius: 6px;
   display: inline-flex;
   flex: 0 0 auto;
   height: 38px;
   justify-content: center;
   width: 38px;
}

.warning-icon {
   background: #92400e;
}

.danger-icon {
   background: #991b1b;
}

.payment-form-body {
   padding: 18px 22px 6px !important;
}

.dialog-note {
   align-items: center;
   background: #fff7ed;
   border: 1px solid #d97706;
   border-radius: 6px;
   color: #7c2d12;
   display: flex;
   font-size: 13px;
   font-weight: 600;
   margin-bottom: 16px;
   padding: 10px 12px;
}

.danger-note {
   background: #fef2f2;
   border-color: #b91c1c;
   color: #7f1d1d;
}

.payment-form-actions {
   border-top: 1px solid #eef2f7;
   padding: 12px 22px 18px;
}

.payment-date-picker-card {
   border-radius: 8px;
   overflow: hidden;
}

.payment-date-picker-title {
   background: #f8fafc;
   border-bottom: 1px solid #e5e7eb;
   padding: 14px 18px;
}

.payment-date-picker-heading {
   color: #0f172a;
   font-size: 16px;
   font-weight: 700;
   line-height: 1.3;
}

.payment-date-picker-subtitle {
   color: #64748b;
   font-size: 12px;
   font-weight: 500;
   margin-top: 2px;
}

.payment-date-picker-body {
   align-items: stretch;
   display: flex;
   gap: 8px;
   padding: 14px !important;
}

.payment-date-picker-body ::v-deep .v-picker {
   box-shadow: none;
}

.payment-date-picker-body ::v-deep .v-date-picker-table,
.payment-date-picker-body ::v-deep .v-time-picker-clock {
   background: #f8fafc;
}

.payment-date-picker-actions {
   background: #f8fafc;
   border-top: 1px solid #e5e7eb;
   padding: 10px 14px;
}

.payment-detail-dialog {
   border-radius: 8px;
}

.payment-detail-title {
   border-bottom: 1px solid #e5e7eb;
}

.payment-detail-subtitle {
   color: #6b7280;
   font-size: 12px;
   font-weight: 400;
   line-height: 1.4;
   margin-top: 2px;
}

.detail-box {
   background: #f9fafb;
   border: 1px solid #e5e7eb;
   border-radius: 6px;
   min-height: 66px;
   padding: 10px 12px;
}

.decline-reason-box {
   background: #fff8f8;
   border-color: #ffcdd2;
}

.detail-label {
   color: #6b7280;
   font-size: 11px;
   font-weight: 600;
   letter-spacing: .4px;
   margin-bottom: 5px;
   text-transform: uppercase;
}

.detail-value {
   color: #111827;
   font-size: 14px;
   font-weight: 500;
   line-height: 1.4;
   overflow-wrap: anywhere;
}

.detail-document-link {
   align-items: center;
   color: #1976d2;
   display: inline-flex;
   font-size: 14px;
   font-weight: 600;
   overflow-wrap: anywhere;
   text-decoration: none;
}

.legacy-payment-table ::v-deep tbody tr td {
   color: #111827;
   font-size: 13px;
   font-weight: 400;
   line-height: 1.4;
   padding-bottom: 7px;
   padding-top: 7px;
}

.payment-data-table ::v-deep tbody tr:hover {
   background: #f8fbff !important;
}

.legacy-payment-table ::v-deep thead tr th {
   color: #374151 !important;
   font-size: 12px;
   font-weight: 600;
   letter-spacing: .1px;
}

.legacy-payment-table ::v-deep .payment-member-row {
   background: #f3f4f6;
}

.legacy-payment-table ::v-deep .payment-member-row td {
   color: #111827;
   font-size: 13px;
   font-weight: 700;
   white-space: nowrap;
}

@media (max-width: 1260px) {
   .payment-header-main {
      max-width: 100%;
   }

   .payment-filter-panel {
      grid-template-columns: 1fr 1fr;
   }
}

@media (max-width: 760px) {
   .payment-filter-panel {
      grid-template-columns: 1fr;
   }
}
</style>
